import React, {Component} from "react";
import {connect} from "react-redux";
import { getLicenseStatus} from "../../actions/actionFooter";
import Proptypes from "prop-types";

class Footer extends Component {

    componentDidMount(){
        this.props.getLicenseStatus();
    }

    render() {
        const {license_info} = this.props;
        let kasmBuildId = `${__KASM_BUILD_ID__}`;
        return (
            <footer className="app-footer">
                <span className="ml-auto">
                    Powered by <a href="https://www.kasmweb.com/" target="blank">Kasm Workspaces {kasmBuildId}</a>
                    <span className="unlicensed-footer">   {license_info.license_info ? (license_info.license_info.status.licensed ? "" : "(Unlicensed)") : ""}</span>
                </span>
            </footer>
        );
    }
}

Footer.propTypes = {
    license_info: Proptypes.object
}

export default connect(
state =>
    ({
        license_info: state.footer || null,
    })
    ,
dispatch =>
    ({
        getLicenseStatus: () => dispatch(getLicenseStatus()),
    })
    )
    (Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js